var ButtonLooks = /*#__PURE__*/ function(ButtonLooks) {
    ButtonLooks["Danger"] = "danger";
    ButtonLooks["Default"] = "default";
    ButtonLooks["Primary"] = "primary";
    ButtonLooks["Secondary"] = "secondary";
    ButtonLooks["Tertiary"] = "tertiary";
    ButtonLooks["TextSecondary"] = "text-secondary";
    ButtonLooks["TextTertiary"] = "text-tertiary";
    ButtonLooks["TextWarning"] = "text-warning";
    ButtonLooks["Warning"] = "warning";
    ButtonLooks["White"] = "white";
    return ButtonLooks;
}({});
var ButtonSizes = /*#__PURE__*/ function(ButtonSizes) {
    /** 225px */ ButtonSizes["Large"] = "large";
    /** 175px */ ButtonSizes["Medium"] = "medium";
    /** 125px */ ButtonSizes["Small"] = "small";
    /** 75px */ ButtonSizes["XSmall"] = "xsmall";
    return ButtonSizes;
}({});
var ButtonVariants = /*#__PURE__*/ function(ButtonVariants) {
    ButtonVariants["Icon"] = "icon";
    ButtonVariants["None"] = "";
    ButtonVariants["Standard"] = "standard";
    ButtonVariants["Tile"] = "tile";
    return ButtonVariants;
}({});

export { ButtonLooks, ButtonSizes, ButtonVariants };
//# sourceMappingURL=button.js.map
